module.exports = __webpack_public_path__ + "img/files-menu.25e14a2a.jpg";